import { put, takeLatest, all, call } from 'redux-saga/effects';
import urls from 'utils/config';
import { networkErrorHandler } from 'utils/errrorHandlers';
import request from 'utils/request';
import {
  fetchInterswitchConfigFailure,
  fetchInterswitchConfigSuccess,
  fetchNabrollConfigFailure,
  fetchNabrollConfigSuccess,
  fetchPayproKanoConfigFailure,
  fetchPayproKanoConfigSuccess,
  fetchPaystackConfigFailure,
  fetchPaystackConfigSuccess,
  fetchPayUnimaidConfigFailure,
  fetchPayUnimaidConfigSuccess,
  fetchRemitaConfigFailure,
  fetchRemitaConfigSuccess,
} from '../actions';
import paymentConfigTypes from '../types';

const { API_BASE_URL } = urls || {};

function* fetchPaystackConfig({ payload: paystack }) {
  if (paystack.length) {
    const paystackResponses = yield all(
      paystack.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = paystackResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchPaystackConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchPaystackConfigFailure('No Paystack configs could be loaded.')
      );
      if (paystackResponses.statusCode === 404) {
        networkErrorHandler(
          paystackResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          paystackResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}
function* fetchNabrollConfig({ payload: nabroll }) {
  if (nabroll.length) {
    const nabrollResponses = yield all(
      nabroll.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = nabrollResponses
      .filter((res) => res.success)
      .map((res) => res.raw);
    if (successfulConfigs.length) {
      yield put(fetchNabrollConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchNabrollConfigFailure(
          'An error occured. Please reload the page to try again.'
        )
      );
      if (nabrollResponses.statusCode === 404) {
        networkErrorHandler(
          nabrollResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          nabrollResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}
function* fetchRemitaConfig({ payload: remita }) {
  if (remita.length) {
    const remitaResponses = yield all(
      remita.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = remitaResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchRemitaConfigSuccess(successfulConfigs));
    } else {
      yield put(fetchRemitaConfigFailure('No Remita configs could be loaded.'));
      if (remitaResponses.statusCode === 404) {
        networkErrorHandler(
          remitaResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          remitaResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}

function* fetchInterswitchConfig({ payload: interswitch }) {
  if (interswitch.length) {
    const interSwitchResponses = yield all(
      interswitch.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = interSwitchResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchInterswitchConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchInterswitchConfigFailure(
          'An error occured. Please reload the page to try again.'
        )
      );
      if (interSwitchResponses.statusCode === 404) {
        networkErrorHandler(
          interSwitchResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          interSwitchResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}
function* fetchPayproKanoConfig({ payload: payproKano }) {
  if (payproKano.length) {
    const payproKanoResponses = yield all(
      payproKano.map((id) =>
        call(request, {
          method: 'get',
          url: `${API_BASE_URL}/paylog-configurations/${id}`,
        })
      )
    );

    const successfulConfigs = payproKanoResponses
      .filter((res) => res.success)
      .map((res) => res.raw);

    if (successfulConfigs.length) {
      yield put(fetchPayproKanoConfigSuccess(successfulConfigs));
    } else {
      yield put(
        fetchPayproKanoConfigFailure('No Paypro Kano configs could be loaded.')
      );
      if (payproKanoResponses.statusCode === 404) {
        networkErrorHandler(
          payproKanoResponses?.statusCode,
          'Please use the correct paylog ID'
        );
      } else {
        networkErrorHandler(
          payproKanoResponses?.statusCode,
          'An error occured. Please reload the page to try again.'
        );
      }
    }
  }
}

function* fetchPayUnimaidConfig({ payload: id }) {
  const url = `${API_BASE_URL}/paylog-configurations/${id}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchPayUnimaidConfigSuccess(response.raw));
  } else {
    yield put(
      fetchPayUnimaidConfigFailure(
        'An error occurred. Please reload the page to try again.'
      )
    );
    if (response.statusCode === 404) {
      networkErrorHandler(
        response?.statusCode,
        'Please use the correct paylog ID'
      );
    } else {
      networkErrorHandler(
        response?.statusCode,
        'An error occurred. Please reload the page to try again.'
      );
    }
  }
}

export function* getPaystackConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYSTACK_CONFIG_REQUEST,
    fetchPaystackConfig
  );
}
export function* getNabrollConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_NABROLL_CONFIG_REQUEST,
    fetchNabrollConfig
  );
}

export function* getRemitaConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_REMITA_CONFIG_REQUEST,
    fetchRemitaConfig
  );
}

export function* getInterswitchConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_REQUEST,
    fetchInterswitchConfig
  );
}
export function* getPayproKanoConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYPRO_KANO_CONFIG_REQUEST,
    fetchPayproKanoConfig
  );
}

export function* getPayUnimaidConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYUNIMAID_CONFIG_REQUEST,
    fetchPayUnimaidConfig
  );
}
